module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-card', {
    staticClass: "mainCardBG"
  }, [_c('b-card-text', [_c('b-navbar', {
    staticClass: "formCard",
    staticStyle: {
      "border-radius": "5px !important",
      "padding-left": "0px"
    },
    attrs: {
      "toggleable": "lg",
      "type": "dark",
      "variant": "primary"
    }
  }, [_c('b-navbar-nav', [_c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "light"
    },
    on: {
      "click": _vm.previousDriverView
    }
  }, [_c('md-icon', {
    attrs: {
      "icon": "gear-fill",
      "aria-hidden": "true"
    }
  }, [_vm._v("skip_previous")]), _vm._v("Back\n          ")], 1)], 1), _vm._v(" "), _c('b-navbar-brand', {
    staticStyle: {
      "margin-left": "0.5rem !important"
    },
    attrs: {
      "center": ""
    }
  }, [_vm._v("Driver Form")])], 1), _vm._v(" "), _c('b-card', {
    staticClass: "formCard"
  }, [_c('b-card-text', [_c('md-layout', {
    staticClass: "mt-2",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "40"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Driver Type")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.driverTypeList,
      "option-value": "driverTypeV",
      "option-text": "driverTypeT",
      "placeholder": "Select Driver Type"
    },
    model: {
      value: (_vm.driverDetail.driverType),
      callback: function($$v) {
        _vm.$set(_vm.driverDetail, "driverType", $$v)
      },
      expression: "driverDetail.driverType"
    }
  })], 1), _vm._v(" "), (!_vm.driverDetail.driverType) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.driverTypeError))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "40"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Driver Name")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "driverName",
      "name": "driverName"
    },
    model: {
      value: (_vm.driverDetail.driverName),
      callback: function($$v) {
        _vm.$set(_vm.driverDetail, "driverName", $$v)
      },
      expression: "driverDetail.driverName"
    }
  })], 1), _vm._v(" "), (!_vm.driverDetail.driverName) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.addDriverError))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Contact No.")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "driverContact",
      "name": "driverContact"
    },
    model: {
      value: (_vm.driverDetail.driverContact),
      callback: function($$v) {
        _vm.$set(_vm.driverDetail, "driverContact", $$v)
      },
      expression: "driverDetail.driverContact"
    }
  })], 1), _vm._v(" "), (!_vm.driverDetail.driverContact) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.addDriverError1))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), (_vm.driverDetail.driverType == '1') ? _c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Vehicle No.")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.vehicleMasterList,
      "option-value": "vehicleTruckId",
      "option-text": "regdNo",
      "placeholder": "Select Vehicle No. "
    },
    model: {
      value: (_vm.driverDetail.vehicleTruckId),
      callback: function($$v) {
        _vm.$set(_vm.driverDetail, "vehicleTruckId", $$v)
      },
      expression: "driverDetail.vehicleTruckId"
    }
  })], 1), _vm._v(" "), (!_vm.driverDetail.vehicleTruckId) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.addTruckError4))]) : _vm._e()], 1) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "40"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Account No.")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "accountNo",
      "name": "accountNo"
    },
    model: {
      value: (_vm.driverDetail.accountNo),
      callback: function($$v) {
        _vm.$set(_vm.driverDetail, "accountNo", $$v)
      },
      expression: "driverDetail.accountNo"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("ESIC")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "driverEsic",
      "name": "driverEsic"
    },
    model: {
      value: (_vm.driverDetail.driverEsic),
      callback: function($$v) {
        _vm.$set(_vm.driverDetail, "driverEsic", $$v)
      },
      expression: "driverDetail.driverEsic"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Working Year")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "driverWorkingYear",
      "name": "driverWorkingYear"
    },
    model: {
      value: (_vm.driverDetail.driverWorkingYear),
      callback: function($$v) {
        _vm.$set(_vm.driverDetail, "driverWorkingYear", $$v)
      },
      expression: "driverDetail.driverWorkingYear"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "mt-3"
  }, [(_vm.showDocSection.length > 0) ? _c('h5', [_c('b-badge', {
    attrs: {
      "variant": "info"
    }
  }, [_vm._v("Driver Documents")])], 1) : _c('b-button', {
    attrs: {
      "id": "show-btn",
      "size": "sm",
      "variant": "dark"
    },
    on: {
      "click": _vm.AddMoreDocs
    }
  }, [_vm._v("Upload Document")])], 1), _vm._v(" "), (_vm.showDocSection.length > 0) ? _c('div', {
    staticClass: "mt-3"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped"
  }, [_c('tbody', [_c('tr', [_c('th', [_vm._v("Sr No.")]), _vm._v(" "), _c('th', [_vm._v("Document Name")]), _vm._v(" "), _c('th', [_vm._v("Upload Document")]), _vm._v(" "), _c('th', [_vm._v("View")]), _vm._v(" "), _c('th', [_c('b-button', {
    staticClass: "mt-2",
    attrs: {
      "size": "sm",
      "variant": "outline-info"
    },
    on: {
      "click": _vm.AddMoreDocs
    }
  }, [_vm._v("Add More\n                      ")])], 1)]), _vm._v(" "), _vm._l((_vm.showDocSection), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_c('model-list-select', {
      attrs: {
        "list": _vm.docList,
        "option-value": "docV",
        "option-text": "docT",
        "placeholder": "Select Document"
      },
      model: {
        value: (item.docName),
        callback: function($$v) {
          _vm.$set(item, "docName", $$v)
        },
        expression: "item.docName"
      }
    }), _vm._v(" "), _c('br'), _vm._v(" "), (item.docName == 'OTHERS') ? _c('b-form-input', {
      attrs: {
        "formatter": _vm.capitalizeAll,
        "name": "otherDocName",
        "id": "otherDocName"
      },
      model: {
        value: (item.otherDocName),
        callback: function($$v) {
          _vm.$set(item, "otherDocName", $$v)
        },
        expression: "item.otherDocName"
      }
    }) : _vm._e()], 1), _vm._v(" "), _c('td', [_c('md-input-container', {
      staticStyle: {
        "margin-top": "-35px"
      }
    }, [_c('md-file', {
      on: {
        "selected": function($event) {
          _vm.onFileChangeKyc(index, item.docName)
        }
      },
      model: {
        value: (item.uploadedDoc),
        callback: function($$v) {
          _vm.$set(item, "uploadedDoc", $$v)
        },
        expression: "item.uploadedDoc"
      }
    })], 1)], 1), _vm._v(" "), _c('td', [(item.uploadedDoc != '') ? _c('a', {
      attrs: {
        "href": _vm.docURL + "/DRIVERMASTER_Uploads/" +
          item.uploadedDoc,
        "target": "_blank",
        "download": ""
      }
    }, [_vm._v("View Document - " + _vm._s(index + 1))]) : _vm._e()]), _vm._v(" "), _c('td', [_c('b-button', {
      attrs: {
        "variant": "outline-danger",
        "size": "sm"
      },
      on: {
        "click": function($event) {
          _vm.removeDoc(index)
        }
      }
    }, [_vm._v("Remove")])], 1)])
  })], 2)])]) : _vm._e(), _vm._v(" "), _c('md-layout', {
    staticClass: "mrgtop-button mt-3",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    staticClass: "justify-content-center"
  }, [_c('b-button', {
    staticClass: "smbutnWidth mt-3",
    attrs: {
      "variant": "primary",
      "id": "addButtonLoader"
    },
    on: {
      "click": _vm.addNewDriver
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('md-spinner', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "md-indeterminate": "",
      "id": "loader"
    }
  })], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('md-dialog-alert', {
    ref: "addPop",
    attrs: {
      "md-content": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    },
    on: {
      "close": _vm.onClose
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-63ff15c2","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/view/driverMaster/driverMaster.vue
// module id = 2685
// module chunks = 0